<template>
  <div
    class="add-refer-file"
    :class="{
      [`add-refer-file--${createRenderType}`]: true,
    }"
  >
    <file-pond
      ref="refUpload"
      v-if="renderData.ifRenderFilePond"
      label-idle="歌曲文件"
      v-bind:allow-multiple="false"
      :acceptedFileTypes="renderData.acceptedFileTypes.join(',')"
      @handleAfterRead="handleAfterRead"
      @addfile="handleAddFile"
      v-bind:files="renderData.files"
    >
    </file-pond>

    <div class="add-refer-file-selectfile pointer" ref="refUploadContent">
      <i class="block"></i>
      <span class="block">{{ $$t("create.song_file") }}</span>
      <label class="vip_plan" v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'">
        {{ $$t("create.pro_plan") }}
      </label>
    </div>
    <div
      class="add-music-reference-edit-mask pointer"
      @click="
        (e) => {
          showSubscribeDialog();
          // goSubscribe(2, 'audioref_local_upload');
        }
      "
      v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
    ></div>
  </div>
  <EditReference
    :editFileName="renderData.editFileName"
    v-model:visible="renderData.editFilePopupVisible"
    v-if="renderData.editFilePopupVisible"
    :clipSourceData="renderData.clipSourceData"
    @complete="handleEditFileCompleted"
  >
  </EditReference>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";

import tools from "@/utils/tools.js";
import Button from "@/components/basic/button/Button.vue";
import IconButton from "@/components/basic/button/IconButton.vue";
import EditReference from "@/page/create/editReference/editReference.vue";

import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js";
import message from "@/components/functionCallComponent/message.jsx";
import clipUtil from "@/components/media/utils/clipUtil.js";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import axios from "axios";

import apiReferMusic from "@/api/api/apiReferMusic.js";
import apiCommon from "@/api/api/apiCommon.js";
import userReferMusicStore from "@/store/create/referMusicStore.js";
import useDraftDataStore from "@/store/create/draftDataStore.js";
import { storeToRefs } from "pinia";

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const referMusicStore = userReferMusicStore();
const draftDataStore = useDraftDataStore();
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
// Create component
const FilePond = vueFilePond();

const refUploadContent = ref(null);
const refUpload = ref(null);
const refInput = ref(null);
const props = defineProps({});
const emits = defineEmits(["saveSuccess"]);
const acceptedFileTypes = [
  "audio/x-wav",
  "video/quicktime",
  "video/mp4",
  "audio/mpeg",
  "audio/wav",
  "audio/x-m4a",
  ".mp3",
  ".wav",
  ".m4a",
  ".mp4",
  ".mov",
  ".MP4",
];
const renderData = reactive({
  ifRenderFilePond: true,
  files: [],
  file: null,
  acceptedFileTypes: acceptedFileTypes,
  editFilePopupVisible: false,
  clipSourceData: null,
  editFileName: "",
});

const checkMediaType = (file) => {
  if (file.type.toLocaleLowerCase().startsWith("audio")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "audio"
      : "unknown";
  } else if (file.type.toLocaleLowerCase().startsWith("video")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "video"
      : "unknown";
  } else {
    return "unknown";
  }
};

const showSubscribeDialog = () => {
  emits("showSubscribeDialog", "reference", {
    membership_source1: "membership_feature",
    membership_source2: "audioref_local_upload",
  });
};

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation();
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    });
  }
};

const initUploadContent = () => {
  if (refUploadContent.value) {
    nextTick(() => {
      refUpload.value?.$el
        .querySelector(".filepond--drop-label")
        .appendChild(refUploadContent.value);
    });
    setTimeout(() => {
      refUpload.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", renderData.acceptedFileTypes.join(","));
    }, 20);
  }
};

const handleSelectFile = () => {
  refUpload.value?.$el.querySelector(".filepond--drop-label").click();
};
const handleAddFile = (error, fileItem, fileList) => {
  if (error) {
    console.error("File add error:", error);
    return;
  }
  console.log("File added:", fileItem);

  handleAfterRead(fileItem.file, 2).then(() => {
    doInitEditFile();
  }).catch((err) => {
    console.error("handleAfterRead error:", err);
  });
};

const handleAfterRead = (e, type = 1) => {
  return new Promise(async (resolve, reject) => {
    let fileType = checkMediaType(e);
    if (fileType == "unknown") {
      message.info({
        position: "top",
        content: $$t("create.select_audio_or_video"),
      });
      reject("not audio type");
      return;
    }
    console.log("File handleAfterRead:", type, e);
    let file = null;
    let blobUrl = "";
    if (e instanceof File) {
      file = e;
    } else {
      if (e.target.files && e.target.files.length > 0) {
        file = e.target.files[0];
      }
      renderData.ifRenderFilePond = false;
      renderData.files = [];
    }
    nextTick(() => {
      renderData.ifRenderFilePond = true;
      nextTick(() => {
        initUploadContent();
      });
    });
    if (!file) return;
    if (file.size > 1024 * 1024 * 100) {
      message.info({
        position: "top",
        content: $$t("create.max_file_size"),
      });
      reject("max file size");
      return;
    }
    try {
      const duration = await tools.getMediaFileDuration(file);
      if (duration > 0) {
        if (duration < 10) {
          message.info({
            position: "top",
            content: $$tValue("create.min_file_duration", { duration: 10 }),
          });
          reject("min file duration");
        } else {
          renderData.duration = duration;
          renderData.file = file;
          resolve();
        }
      } else {
        console.log("getMediaFileDuration", duration, file?.name, file?.type);
        message.info({
          position: "top",
          content: $$t("create.select_audio_or_video"),
        });
        reject("not audio duration");
        return;
      }
    } catch (e) {
      try {
        const outputfile = await ffmpegUtil.transFileToMp3(file);
        let duration = 0;
        if (outputfile) {
          duration = await tools.getMediaFileDuration(outputfile.file);
        }
        if (duration > 0) {
          if (duration < 10) {
            message.info({
              position: "top",
              content: $$tValue("create.min_file_duration", { duration: 10 }),
            });
            reject("min file duration");
          } else {
            renderData.duration = duration;
            renderData.file = outputfile.file;
            resolve();
          }
        } else {
          console.log(
            "transFileToMp3 getMediaFileDuration",
            duration,
            file?.name,
            file?.type
          );
          message.info({
            position: "top",
            content: $$t("create.select_audio_or_video"),
          });
          reject("not audio ffmpeg duration");
          return;
        }
      } catch (e) {
        console.log("not audio ffmpeg", e, file?.name, file?.type);
        message.info({
          position: "top",
          content:
            fileType == "video"
              ? $$t("create.select_video_error")
              : $$t("create.select_audio_error"),
        });
        reject("not audio");
      }
    }
  });
};

const doInitEditFile = async (filep, isLink) => {
  let file = renderData.file ?? filep;
  renderData.editFileName = file?.name
    ?.replace(/.[a-zA-Z0-9]+$/, "")
    ?.slice(0, 60);
  console.log("doInitEditFile", file.type, file);
  window.curSelectFile = file;
  const closeMsg = message.loading({
    content: isLink ? $$t("create.parsing_link") : $$t("create.extract_song"),
  });
  let decodeData = null;
  let blobUrl = null;
  let duration = 0;
  try {
    decodeData = await clipUtil.getDecodeDataByFile(file);
    duration = decodeData.duration;
    blobUrl = (window.URL || window.webkitURL).createObjectURL(file);
  } catch (e) {
    try {
      console.log("name:", file.name, "type:", file.type, "size:", file.size);
      const outputfile = await ffmpegUtil.transFileToMp3(file);
      file = outputfile.file;
      blobUrl = outputfile.blobUrl;
      decodeData = await clipUtil.getDecodeDataByFile(file);
      duration = decodeData.duration;
    } catch (e) {
      console.error("handleAfterReaderr", e);
      closeMsg.clear();
      message.info({
        content: $$t("create.extract_song_failed"),
      });
      return;
    }
  }
  renderData.fileTemp = file;

  console.log("renderEditFile", renderData.clipSourceData);
  closeMsg.clear();

  renderData.editFilePopupVisible = true;
  nextTick().then(() => {
    renderData.clipSourceData = {
      duration: duration,
      isUpload: true,
      blobUrl: blobUrl,
      url: null,
      type: "audio/wav",
      decodeData,
    };
  });
};

const handleEditFileCompleted = async (fileData, close) => {
  const { getClipedExportData, data } = fileData;
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  });
  let saveData = null;
  try {
    let clipedExportData = await getClipedExportData();
    if (clipedExportData.blob.type != "audio/mp3") {
      try {
        let transfile = await ffmpegUtil.transFileToMp3(
          new File([clipedExportData.blob], "output.wav", { type: "audio/wav" })
        );
        clipedExportData.url = transfile.blobUrl;
        clipedExportData.blob = transfile.blob;
        clipedExportData.file = transfile.file;
      } catch (e) {
        console.error("transFileToMp3 error", e);
      }
    }
    const fileSaveData = {
      url: clipedExportData.url,
      filename: data.filename,
      mood: data.moodTag?.value,
      genre: data.styleTag?.value,
      duration: clipedExportData.duration,
    };

    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      clipedExportData.file,
      (obj) => {
        renderData.uploadCallbackData = obj;
      }
    );
    saveData = {
      url: objectStorageRes.pathKey,
      duration_milliseconds: Math.ceil(fileSaveData.duration * 1000),
      upload_link: null,
      // feed_id: draftDataStore.feed_id,
      title: fileSaveData.filename,
      source_type: 2,
      mood: fileSaveData.mood,
      genre: fileSaveData.genre,
      resource: null,
    };
  } catch (e) {
    closeMsg.clear();
    console.error("uploadFileToObjectStorage error", e);
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    });
    return;
  }

  apiReferMusic
    .addReferenceMusic(saveData)
    .then((res) => {
      closeMsg?.clear();
      if (res.code == 200 && res.data) {
        renderData.file = null;
        renderData.addLinkDialogVisible = false;
        close();
        renderData.clipSourceData = null;
        emits("saveSuccess", res.data, true);
      } else {
        if (res.code == 6352) {
          message.info({
            position: "top",
            content: $$t("create.generate_refer_audit_failed"),
          });
        } else if (res.code == 6320) {
          message.error({
            position: "top",
            content: $$t("create.song_cover_auditing_failed"),
          });
        } else if (res.code == 6316) {
          message.error({
            position: "top",
            content: $$t("create.song_title_audit_failed"),
          });
        } else {
          message.error({
            position: "top",
            content: $$t("create.save_failed"),
          });
        }
      }
    })
    .catch((err) => {
      closeMsg?.clear();
      console.error("addReferenceMusic error", err);
      message.error({
        position: "top",
        content: $$t("create.save_failed"),
      });
    });
};

onMounted(() => {
  nextTick(() => {
    initUploadContent();
  });
});
</script>
<style lang="scss">
.add-refer-file {
  position: relative;
  .add-music-reference-edit-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .add-refer-file-selectfile {
    height: 56px;
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(148, 173, 255, 0.1);
    i {
      height: 20px;
      width: 20px;
      min-width: 20px;
      background: url("@/assets/img/upload-white-ico.png") no-repeat center;
      background-size: 100% 100%;
    }
    span {
      margin-left: 4px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
    }
    label.vip_plan {
      min-width: max-content;
      height: 14px;
      border-radius: 2px;
      background: linear-gradient(
        110deg,
        #ffe08b 0%,
        #fff7d0 47%,
        #ffe08b 100%
      );
      padding: 0 3px;
      line-height: 14px;
      
      font-size: 8px;
      font-weight: 500;
      color: #3d2d00;
      margin: 0 0 0 8px;
    }
    &:hover {
      background: rgba(148, 173, 255, 0.2);
    }
  }
  .filepond--root {
    height: 56px !important;
    min-height: 56px !important;
    background: transparent;
    box-shadow: none;
    border-radius: 56px;
    align-items: center;
    justify-content: center;
    border-radius: 56px;
    margin: 0;
    .filepond--wrapper {
      height: 56px !important;
      border-radius: 56px;
    }
    .filepond--browser.filepond--browser {
      height: 0;
    }
    .filepond--list-scroller {
      display: none;
    }
    .filepond--credits {
      display: none;
    }

    .filepond--panel-root {
      border-radius: 0.5em;
      background: transparent;
      box-shadow: none;
      border-radius: 56px;
      display: none;
    }

    .filepond--assistant {
      display: block;
    }
    .filepond--drop-label {
      display: block;
      visibility: visible !important;
      transform: translate3d(0px, 0, 0px) !important;
      height: 56px !important;
      border-radius: 56px !important;
      min-height: 56px !important;
      opacity: 1 !important;
      pointer-events: auto !important;
      & > label {
        width: 0;
        height: 0;
        overflow: hidden;
        padding: 0;
      }
    }
    &[data-hopper-state="drag-over"] {
      .add-refer-file-selectfile {
        border: 1px dashed #94adff;
      }
    }
  }
  &.add-refer-file--mobile {
    .add-vocal-file-desc {
      margin: 4px auto 0 auto;
    }
    .add-refer-file-selectfile {
      padding: 0 6px;
      span {
        font-size: 12px;
      }
    }
  }
}
</style>
